import { QueryFeature } from '../../../../../../config/queryClient';

enum QueryKey {
  AssetBucketingDetails = 'AssetBucketingDetails',
}

export const queryKeys = {
  assetBucketDetails: (clientId: string) => [
    QueryFeature.AssetBucketingEdit,
    QueryKey.AssetBucketingDetails,
    clientId,
  ],
};
